// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"164":"terms","845":"QRcode","957":"privacy"}[chunkId] || chunkId) + "." + {"9":"95e11795","164":"3147d9c0","190":"1259e3f7","314":"57c640db","405":"c66d49c5","623":"84d84a73","640":"ce56a910","845":"ce502470","956":"ee3a13ce","957":"06178b85"}[chunkId] + ".js";
};